import React from 'react';
import { Alert, ListGroup } from 'react-bootstrap';
import { FaChevronRight, FaLock, FaUser, FaUserCog } from 'react-icons/fa';
import { resolveAuthorColor } from '../../platform/chatAuthorColors';
import {
  formatLifecycleDate,
  isAccountPendingDeletion,
} from '../../platform/accountLifecycle';
import ProfileAvatar from '../common/ProfileAvatar';
import './ProfileHub.css';
function getTimeGreeting() {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 11) return 'Dobro jutro';
  if (hour >= 11 && hour < 18) return 'Dober dan';
  return 'Dober večer';
}

function buildGreeting(profile) {
  const firstName = profile.firstName?.trim();
  const greeting = getTimeGreeting();
  if (firstName) {
    return `${greeting}, ${firstName}!`;
  }
  return `${greeting}!`;
}

function buildMenuItems(pendingDeletion) {
  return [
    {
      id: 'edit',
      label: 'Osebni podatki',
      description: 'Uredite svojo fotografijo, kontaktne podatke in barvo v klepetu',
      icon: FaUser,
    },
    {
      id: 'security',
      label: 'Varnost',
      description: 'Zavarujte svoj račun z močnim geslom',
      icon: FaLock,
    },
    {
      id: 'account',
      label: 'Račun',
      description: pendingDeletion
        ? 'Prekličite ali upravljajte načrtovani izbris računa'
        : 'Začasno onemogočite ali trajno izbrišite račun',
      icon: FaUserCog,
    },
  ];
}

function ProfileHub({
  profile,
  photoPreviewUrl,
  onSelectView,
  tenantDisplayName,
}) {
  const displayName = [profile.firstName, profile.lastName].filter(Boolean).join(' ').trim()
    || profile.displayName
    || profile.email
    || 'Uporabnik';

  const authorColor = resolveAuthorColor(profile.uid, profile.chatColor);
  const greeting = buildGreeting(profile);
  const pendingDeletion = isAccountPendingDeletion(profile);
  const scheduledDeletionLabel = formatLifecycleDate(profile.scheduledDeletionAt);
  const menuItems = buildMenuItems(pendingDeletion);

  return (
    <div className="profile-hub">
      <div className="profile-hub__hero">
        <div className="profile-hub__hero-bg" aria-hidden="true" />
        <div
          className="profile-hub__hero-content"
          style={{ '--profile-accent': authorColor }}
        >
          <p className="profile-hub__greeting">{greeting}</p>

          <div className="profile-hub__avatar-wrap">
            <ProfileAvatar
              uid={profile.uid}
              photoURL={photoPreviewUrl || profile.photoURL}
              displayName={displayName}
              authorColor={profile.chatColor}
              photoClassName="profile-hub__avatar-image"
              initialsClassName="profile-hub__avatar-initials"
            />
          </div>
          <h2 className="profile-hub__name">{displayName}</h2>
          {profile.email && (
            <p className="profile-hub__email">{profile.email}</p>
          )}

          {tenantDisplayName && (
            <div className="profile-hub__meta">
              <span className="profile-hub__chip">{tenantDisplayName}</span>
            </div>
          )}

          {pendingDeletion && (
            <Alert variant="warning" className="profile-hub__pending-alert mb-0">
              Račun bo trajno izbrisan
              {scheduledDeletionLabel ? ` ${scheduledDeletionLabel}` : ' po preteku roka'}.
            </Alert>
          )}
        </div>
      </div>

      <h2 className="platform-section-title">Vaše nastavitve</h2>

      <ListGroup className="profile-hub__menu">
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <ListGroup.Item
              key={item.id}
              action
              className="profile-hub__menu-item platform-content-list-item"
              onClick={() => onSelectView(item.id)}
            >
              <div className="profile-hub__menu-main">
                <div className="profile-hub__menu-icon" aria-hidden="true">
                  <Icon />
                </div>
                <div className="profile-hub__menu-body">
                  <div className="profile-hub__menu-title">
                    {item.label}
                    {item.id === 'account' && pendingDeletion && (
                      <span className="profile-hub__badge">Načrtovan izbris</span>
                    )}
                  </div>
                  <div className="profile-hub__menu-description">{item.description}</div>
                </div>
                <FaChevronRight className="profile-hub__menu-chevron" aria-hidden="true" />
              </div>
            </ListGroup.Item>
          );
        })}
      </ListGroup>
    </div>
  );
}

export default ProfileHub;
